/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiserviceMelcoModelsColorCollection,
    ApiserviceMelcoModelsColorCollectionFromJSON,
    ApiserviceMelcoModelsColorCollectionFromJSONTyped,
    ApiserviceMelcoModelsColorCollectionToJSON,
    ApiserviceMelcoModelsDesignElementColor,
    ApiserviceMelcoModelsDesignElementColorFromJSON,
    ApiserviceMelcoModelsDesignElementColorFromJSONTyped,
    ApiserviceMelcoModelsDesignElementColorToJSON,
    ApiserviceMelcoModelsDesignLetteringElement,
    ApiserviceMelcoModelsDesignLetteringElementFromJSON,
    ApiserviceMelcoModelsDesignLetteringElementFromJSONTyped,
    ApiserviceMelcoModelsDesignLetteringElementToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApiserviceMelcoModelsDesignElement
 */
export interface ApiserviceMelcoModelsDesignElement {
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignElement
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignElement
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignElement
     */
    type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiserviceMelcoModelsDesignElement
     */
    editable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiserviceMelcoModelsDesignElement
     */
    is_required?: boolean;
    /**
     * 
     * @type {ApiserviceMelcoModelsDesignElementColor}
     * @memberof ApiserviceMelcoModelsDesignElement
     */
    color?: ApiserviceMelcoModelsDesignElementColor;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignElement
     */
    color_collection_id?: string | null;
    /**
     * 
     * @type {ApiserviceMelcoModelsColorCollection}
     * @memberof ApiserviceMelcoModelsDesignElement
     */
    color_collection?: ApiserviceMelcoModelsColorCollection;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignElement
     */
    default_color_id?: string | null;
    /**
     * 
     * @type {ApiserviceMelcoModelsDesignLetteringElement}
     * @memberof ApiserviceMelcoModelsDesignElement
     */
    lettering?: ApiserviceMelcoModelsDesignLetteringElement;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignElement
     */
    active_color_group_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsDesignElement
     */
    lettering_id?: string | null;
}

export function ApiserviceMelcoModelsDesignElementFromJSON(json: any): ApiserviceMelcoModelsDesignElement {
    return ApiserviceMelcoModelsDesignElementFromJSONTyped(json, false);
}

export function ApiserviceMelcoModelsDesignElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiserviceMelcoModelsDesignElement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'editable': !exists(json, 'editable') ? undefined : json['editable'],
        'is_required': !exists(json, 'is_required') ? undefined : json['is_required'],
        'color': !exists(json, 'color') ? undefined : ApiserviceMelcoModelsDesignElementColorFromJSON(json['color']),
        'color_collection_id': !exists(json, 'color_collection_id') ? undefined : json['color_collection_id'],
        'color_collection': !exists(json, 'color_collection') ? undefined : ApiserviceMelcoModelsColorCollectionFromJSON(json['color_collection']),
        'default_color_id': !exists(json, 'default_color_id') ? undefined : json['default_color_id'],
        'lettering': !exists(json, 'lettering') ? undefined : ApiserviceMelcoModelsDesignLetteringElementFromJSON(json['lettering']),
        'active_color_group_id': !exists(json, 'active_color_group_id') ? undefined : json['active_color_group_id'],
        'lettering_id': !exists(json, 'lettering_id') ? undefined : json['lettering_id'],
    };
}

export function ApiserviceMelcoModelsDesignElementToJSON(value?: ApiserviceMelcoModelsDesignElement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'type': value.type,
        'editable': value.editable,
        'is_required': value.is_required,
        'color': ApiserviceMelcoModelsDesignElementColorToJSON(value.color),
        'color_collection_id': value.color_collection_id,
        'color_collection': ApiserviceMelcoModelsColorCollectionToJSON(value.color_collection),
        'default_color_id': value.default_color_id,
        'lettering': ApiserviceMelcoModelsDesignLetteringElementToJSON(value.lettering),
        'active_color_group_id': value.active_color_group_id,
        'lettering_id': value.lettering_id,
    };
}


